(() => {
  const pageContext = () => ({
    page_path: window.location.pathname,
    page_title: document.title,
    template: document.querySelector('#MainContent')?.dataset.template || '',
  });

  const publish = (eventName, eventData = {}) => {
    const detail = { ...pageContext(), ...eventData };
    document.dispatchEvent(new CustomEvent(eventName, { detail }));

    const shopifyPublish = window.Shopify?.analytics?.publish;
    if (typeof shopifyPublish !== 'function') return;

    try {
      Promise.resolve(shopifyPublish.call(window.Shopify.analytics, eventName, detail)).catch(() => {});
    } catch (_) {}
  };

  const productContext = (element) => {
    const planner = element?.closest?.('[data-bf-purchase-planner]')
      || document.querySelector('[data-bf-purchase-planner]');
    if (!planner) return {};

    return {
      product_id: planner.dataset.bfProductId || '',
      product_handle: planner.dataset.bfProductHandle || '',
      variant_id: planner.dataset.bfVariantId || '',
      service_mode: planner.dataset.bfServiceMode || '',
    };
  };

  const linkPlacement = (link) => {
    if (link.matches('.bf-whatsapp')) return 'floating_button';
    if (link.closest('[data-bf-purchase-planner]')) return 'product_planner';
    if (link.closest('header')) return 'header';
    if (link.closest('footer')) return 'footer';
    return 'content';
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }

    const searchResult = link.closest('[data-bf-search-result]');
    if (url.origin === window.location.origin && searchResult) {
      const allowedTypes = ['product', 'article', 'page', 'intent_route'];
      const allowedSurfaces = ['search_page', 'predictive_search'];
      const resourceType = searchResult.dataset.bfSearchResult || '';
      const searchSurface = searchResult.dataset.bfSearchSurface || '';
      const resultPosition = Number.parseInt(searchResult.dataset.bfSearchPosition || '', 10);

      if (allowedTypes.includes(resourceType) && allowedSurfaces.includes(searchSurface)) {
        publish('bimmerfit:search_result_click', {
          page_title: '',
          search_surface: searchSurface,
          resource_type: resourceType,
          result_position: Number.isInteger(resultPosition) && resultPosition > 0 && resultPosition <= 50
            ? resultPosition
            : 0,
          target_path: url.pathname,
        });
      }
    }

    const internalNavigation = link.closest('[data-bf-internal-navigation]');
    const editorialCta = link.closest('.bf-seo-cta');
    const editorialQuicklinks = link.closest('.bf-seo-quicklinks');
    if (url.origin === window.location.origin && (internalNavigation || editorialCta || editorialQuicklinks)) {
      publish('bimmerfit:internal_navigation_click', {
        placement: internalNavigation?.dataset.bfInternalNavigation
          || (editorialCta ? 'editorial_cta' : 'editorial_quicklinks'),
        target_path: url.pathname,
        link_label: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120),
      });
    }

    if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) return;

    publish('bimmerfit:whatsapp_click', {
      ...productContext(link),
      placement: linkPlacement(link),
      link_label: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120),
    });
  }, true);

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    const placement = form.dataset.bfInternalNavigation || '';
    if (!placement) return;

    let url;
    try {
      url = new URL(form.action, window.location.href);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin) return;

    publish('bimmerfit:internal_navigation_click', {
      placement,
      target_path: url.pathname,
    });
  }, true);

  window.BimmerfitConversion = Object.freeze({ publish });
})();
